export default __webpack_public_path__ + "static/media/partners-logo-hanyang-w.ea3b1490.webp";